import { type FC, forwardRef } from 'react';
import { ButtonIcon as ButtonIconBase } from '@mwl/ui';
import { Button } from '../Button/Button';
import type { ButtonIconProps } from './ButtonIcon.types';
const ButtonIcon: FC<ButtonIconProps> = forwardRef<HTMLButtonElement, ButtonIconProps>(({
  rounded,
  variant = 'text',
  ...props
}, ref) => {
  return <ButtonIconBase ref={ref} component={Button} {...props} variant={variant} radius={rounded ? 'xl' : 'sm'} />;
});
ButtonIcon.displayName = 'ButtonIcon';
export * from './ButtonIcon.types';
export { ButtonIcon };